import { Box, Flex, HStack, Image, Text } from '@chakra-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import NewUser from '../../../assets/new_user.svg';
import ReturningUser from '../../../assets/returning_user.svg';

const InfoImage = ({ image, label, onClick }) => (
  <Flex
    flexDir="column"
    cursor="pointer"
    onClick={onClick}
    mx={40}
    justifyContent="center"
  >
    <Image src={image} height="150px" />
    <Text
      borderRadius={100}
      borderColor="#d1d3d4"
      borderWidth="1px"
      p={1}
      w="140px"
      fontWeight="bold"
      mt={4}
      textAlign="center"
    >
      {label}
    </Text>
  </Flex>
);

const EnterUserType = ({ nextPage }) => {
  const history = useHistory();

  return (
    <Box p={8}>
      <HStack justifyContent="center" mb={8}>
        <InfoImage
          label="New User"
          onClick={() => history.push('/offers/all')}
          image={NewUser}
        />

        <InfoImage
          label="Returning User"
          onClick={nextPage}
          image={ReturningUser}
        />
      </HStack>
    </Box>
  );
};

export default EnterUserType;
